import React from 'react';
import { COMUNICACION_DATA } from '@/data/mock';
import { SolutionPageLayout } from '@/components/shared/SharedComponents';
import {
  LayoutDashboard, Bot, Users, Zap, BarChart3, Bell,
  Globe, HardHat, GitMerge
} from 'lucide-react';

const featureIcons = { LayoutDashboard, Bot, Users, Zap, BarChart3, Bell };
const audienceIcons = { Globe, HardHat, GitMerge };

export default function ComunicacionPage() {
  return (
    <SolutionPageLayout
      heroData={COMUNICACION_DATA.hero}
      features={COMUNICACION_DATA.features}
      stats={COMUNICACION_DATA.stats}
      audiences={COMUNICACION_DATA.audiences}
      featureIcons={featureIcons}
      audienceIcons={audienceIcons}
    />
  );
}
